import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from "react-router-dom";
import '../../../src/custom.css'
import Header from '../PageLayout/Header';
import Footer from '../PageLayout/Footer';
import Edit_light from "../../assets/images/Edit_light.svg";
import { Select } from 'antd';
import Loader from "../loader";
import toast, { Toaster, useToasterStore } from 'react-hot-toast';
import { fetchUsersWithCompanies, fetchUserCompanyById, fetchUserMenudata, fetchUserRoledata } from "../../Redux/Api/fetch.api";
import axios from "axios";
import * as url from "../../api/uri_helper";
import Table, { TableProps } from "antd/lib/table";
import Trash_light from "../../assets/images/Trash_light.svg";
import { Modal } from 'antd';
import Add from "../../assets/images/Add.svg";
import Layout from '../Layout';
import { Tooltip } from 'antd';
import { getusercompanydata, deleteusercompanydata } from '../../Redux/Actions/UserCompanyAction';
import { getuserroleandmenu } from '../../Redux/Actions/UsersActions';
import searchIcon from "../../assets/images/SearchIcon.svg";
import NotAuthorised from "../Authentication/NotAuthorised";
import { useTranslation } from "react-i18next";
import Title from "../Title";

const UserCompanyView = ({allSubCompanies, roleId, setIsAccordionOpen, setIsCompanyEdit, setIsCompanyAdded, setSubCompanyId, setSiteId,setAllowNotification,setAllowSMS,setAllowMaintenance, setAllowUpdate,
     handleAccordionToggle, userCompanyRef,setOpenAccordion, isCompanyAdded, setIsSiteUpdateClick}) => {
    const { t} = useTranslation('userCompany');
    const { REACT_APP_DEFAULT_PAGESIZE } = process.env;   
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();     
    const [table, setTable] = useState([]);
    const [pageSize, setPageSize] = useState(REACT_APP_DEFAULT_PAGESIZE);  // dynamic
    const [options, setOptions] = useState({
        pagination: {
            current: 1,
            pageSize: pageSize,
            pageSizeOptions: ['50', '100'],
            showSizeChanger: true,
        },
    });
    
   // const [options, setOptions] = useState({ pagination: { current: 1 }, pageSize: pageSize });
    const [totalIndex, setCurrentIndex] = useState()
    const [pageData, setPageData] = useState({});
    const [total, setTotal] = useState()
    let history = useHistory();
    const loggedUserId = localStorage.getItem('UserId')
   
    const [search, setSearch] = useState("")
    const [searchData, setSearchData] = useState()
    const [searchClicked, setSearchClicked] = useState(false)
    const [searchError, setSearchError] = useState()
    const [userName, setUserName] = useState("")
    const [searchSubCompany, setSearchSubCompany] = useState("")
    const [resetDisplay, setResetDisplay] = useState(false);
   
    useEffect(() => {      
        if(allSubCompanies || isCompanyAdded) {
            getallUserswithcompanies();
        }                
    }, [allSubCompanies, isCompanyAdded])
          
    const getallUserswithcompanies = (isReset = false) => {        
        setLoading(true)
        fetchUsersWithCompanies({
            UserId: loggedUserId,
            ...(isReset ? { UserName: "" } : userName ? { UserName: userName } : {}),
        })
            .then(response => {
                dispatch(getusercompanydata(response.data))
                setTable(response.data.data)               
                setOptions({
                    ...options,
                    pagination: {
                        ...options.pagination,
                        total: response.data.count,
                    },
                });
            })
            .catch((err) => {
                console.log("Err: ", err);
            });            
            setLoading(false)         
    }
    const formattedData = [{
        key: "1", // Unique key for a single row
        subCompanyName: allSubCompanies.map(company => company.subCompanyName).join(", ")
    }];
    const SearchControl = async () => {
        if (searchSubCompany !== '') {
            setResetDisplay(true);
        }

        else if (searchSubCompany == '' && resetDisplay) {
            setResetDisplay(false);
        }
        getallUserswithcompanies();
    }

    const handleKeyPress = (e) => {
        
        if (e.key === "Enter") {
            
            SearchControl();

        }
    }

    const handleResetButton = () => {
        setResetDisplay(false);
        setSearchSubCompany("")
        getallUserswithcompanies(true);
    }

    const deleteUserCompanyRecord = async (userid) => {
        debugger;
        setLoading(true)
        await axios.delete(url.DELETE_USERCOMPANY + '/' + userid, {
        }).then(response => {
            debugger;
            dispatch(deleteusercompanydata(response.data))
            setTimeout(() => {
                setLoading(false)
            }, 1000)
            toast.success(t("SubCompanyDeletedSuccessfully"), {
                className: "toastSuccess",
            },);
            getallUserswithcompanies()

        }).catch((err) => {
            console.log("Err: ", err);
        });
        setLoading(false)



    }

    const { confirm } = Modal;
    const handleDelete = (userId) => {
        confirm({
            title: t('Areyousure'),
            okText: t('Yes'),
            okType: 'danger',
            cancelText: t('No'),
            onOk() {
                deleteUserCompanyRecord(userId)
            },
            onCancel() {
            },
        });
    }

    const handleChange = (pagination, sorter, current) => {
        const updatedOptions = { ...options, pagination };
        setOptions(updatedOptions);
        setPageData(updatedOptions)
    };

    const bindCompany = (userCompany) => {

        return userCompany.map(x => x.companyName).join(", ");
    }

    const handleEdit = () => {
       setIsAccordionOpen(true)
        setIsCompanyAdded(false)
        setIsCompanyEdit(true)
        setIsSiteUpdateClick(false)
        setSiteId()
        setSubCompanyId()
        setAllowNotification()
        setAllowSMS()
        setAllowMaintenance()
        setAllowUpdate()
        setOpenAccordion("userCompany")
          
        // history.push('/UserCompany/edit/' + userId)
    }

    const columns = [
       
        {
            title: t("SubCompanies"),
            dataIndex: "subCompanyName",
            className: "subcompany",
            render: (_, record) => {
                // Extract all subCompanyName values from allSubCompanies
                const companyNames = allSubCompanies.map(company => company.subCompanyName).join(", ");
        
                return (
                    <div className="ellips-dec">
                        <Tooltip title={companyNames}>{companyNames}</Tooltip>
                    </div>
                );
            },
        },
         ...(roleId === 7
             ? [
                  {
                      title: t("Action"),
                      dataIndex: "",
                      render: (_, record) => (
                          <button className="table-btn">
                              <img
                                  src={Edit_light}
                                  onClick={() => handleEdit()}
                                  alt="Edit"
                              />
                          </button>
                      ),
                  },
               ]
             : []),
    ];

    return (
        <div>
            
            {allSubCompanies.length > 0 || isCompanyAdded == true ?
                   
                        <div className="Company_section">
                        <Toaster />
                            <div className=" w-100 position-relative wk-select user-detail-table">
                                <h4 className="m-0">{t("UserCompanyRelation")}</h4>
                                
                            </div>

                            <div className="Viewer-table index--table position-relative common-table mb-4">
                              
                                <Table
                                    className='antd--detail-table1'
                                    columns={columns}
                            dataSource={formattedData}
                            pagination={false}
                                   // pagination={options.pagination.total > REACT_APP_DEFAULT_PAGESIZE ? options.pagination : false}                                    
                                    onChange={handleChange}
                                   // paginationTotalRows={total}
                                />
                            </div>
                    </div> 
                    
            :''}
        </div>
    )
}
export default connect()(UserCompanyView);
